import { render, staticRenderFns } from "./PxRolesGrid.vue?vue&type=template&id=1c35de4c"
import script from "./PxRolesGrid.vue?vue&type=script&lang=js"
export * from "./PxRolesGrid.vue?vue&type=script&lang=js"
import style0 from "./PxRolesGrid.vue?vue&type=style&index=0&id=1c35de4c&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c35de4c')) {
      api.createRecord('1c35de4c', component.options)
    } else {
      api.reload('1c35de4c', component.options)
    }
    module.hot.accept("./PxRolesGrid.vue?vue&type=template&id=1c35de4c", function () {
      api.rerender('1c35de4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/refactoring/PxRolesGrid.vue"
export default component.exports